console.log("Bundle Accessories Loaded");

document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("submit", async (event) => {

    const form = event.target;

    if (!form.matches('form[action*="/cart/add"]')) return;

    requestAnimationFrame(async () => {

      const items = [];

["shock", "fork", "pinion", "crankset"].forEach(name => {

  let value = "";

  // First look for a dropdown
  const select = document.getElementById(`${name}-select`);

  if (select) {
    value = select.value;
  } else {
    // Otherwise look for the old radio buttons
    const radio = document.querySelector(`input[name="${name}"]:checked`);
    if (radio) {
      value = radio.value;
    }
  }

  if (value) {
    items.push({
      id: Number(value),
      quantity: 1
    });
  }

});

      console.log("Accessories found:", items);

      if (!items.length) return;

      // Wait for Dawn to finish adding the bike
      setTimeout(async () => {

        try {

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              items: items
            })
          });

          console.log("Accessory response:", await response.json());

          document.dispatchEvent(new CustomEvent("cart:refresh"));

        } catch (e) {

          console.error(e);

        }

      }, 700);

    });

  });

});